import App from './App.vue';

export default {
  path: '/CDS_VF_HeliportTotalList',
  name: 'CDS_VF_HeliportTotalList',
  component: App,
  meta: {
    pageProperty: {
      title: 'ヘリポート集計',
      controller: 'CDS_CTR_HeliportTotalList',
    },
  },
};
